import React from 'react';
import { computePointsAheadPercent } from '../utils/roundPointBuckets';

export default function UserRoundPosition({
  totalPoints,
  pointBuckets,
  statusLabel,
  className = ''
}) {
  const position =
    totalPoints != null && pointBuckets
      ? computePointsAheadPercent(totalPoints, pointBuckets)
      : null;
  if (!position && !statusLabel) return null;

  const rankLabel = position
    ? position.totalPoints === 0
      ? `You and ${position.percent}% of other players are at 0 pts`
      : `Equal to or ahead of ${position.percent}% of other players`
    : null;

  return (
    <div
      className={`user-round-position${statusLabel && !position ? ' user-round-position--status-only' : ''}${className ? ` ${className}` : ''}`}
      role="status"
    >
      {statusLabel ? (
        <span className="user-round-position__status">{statusLabel}</span>
      ) : null}
      {position ? (
        <span className="user-round-position__score">
          <strong>{position.totalPoints} pts</strong>
          <span className="user-round-position__rank">{rankLabel}</span>
        </span>
      ) : null}
    </div>
  );
}
